export default __webpack_public_path__ + "static/js-3dfb665e058d08c99f280c337cc94fd7.png";